<template>
  <mdb-container class="gp-has-header">
    <div v-if="showMain" class="text-left">
      <mdb-btn icon="plus-circle" @click="newQuery">New</mdb-btn>
      <data-table :clickHandler="openQuery"
                  :columns="columns"
                  dataSource="/batch/queryList"
                  pageTitle="Queries"/>
    </div>
    <div v-if="showQuery">
      <mdb-card class="mb-4">
        <mdb-card-body class="text-left">
          <mdb-btn @click="cancelShow" icon="arrow-left">Back</mdb-btn>
          <mdb-input disabled label="ID" type="text" v-model="currentQuery.id"/>
          <mdb-input label="Name" type="text" v-model="currentQuery.name"/>
          <div class="md-form text-left mb-4">
            <gp-select :dataObj="currentQuery" :possible-values="validTypes" :required="true" label="Type"
                       propertyName="type"/>
            <mdb-input v-if="currentQuery.type == 'HQL'" label="Domain Name" type="text" v-model="currentQuery.domainName"/>
            <mdb-input label="Parameter Names (comma separated)" type="text" v-model="currentQuery.parameters"/>
            <ace-editor v-model="currentQuery.code" lang="sql" @init="editorInit" theme="chrome" width="100%" height="250"></ace-editor>
          </div>

          <div v-if="currentQuery.id && currentQuery.code == oldCode && currentQuery.parameters">
            <mdb-input label="Test Payload (JSON)" type="textarea" :rows="2" v-model="testPayload"/>
          </div>

          <div>
            <mdb-btn @click="saveQuery" icon="save" color="success">Save</mdb-btn>
            <mdb-btn v-if="currentQuery.id && currentQuery.code == oldCode" @click="testQuery" icon="bolt">Test</mdb-btn>
            <mdb-btn v-if="currentQuery.id" @click="showDeleteModal=true" icon="trash" color="danger">Delete</mdb-btn>
          </div>

          <div id="results-scroller">&nbsp;</div>
        </mdb-card-body>
      </mdb-card>
      <mdb-card v-show="showResults" id="results">
        <mdb-card-header>
          <h3>Results
              <mdb-btn @click="showResults = false" size="sm" rounded icon="minus-circle">Close</mdb-btn>
          </h3>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <pre>
          {{ queryResults }}
          </pre>
          <mdb-btn @click="showResults = false" icon="minus-circle">Close</mdb-btn>
        </mdb-card-body>
      </mdb-card>
    </div>


    <yes-no-modal v-if="showDeleteModal" @yes="deleteQuery" @no="showDeleteModal=false"></yes-no-modal>
  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbInput} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import gpSelect from "../common/GPSelect";
import YesNoModal from "../common/YesNoModal";
import AceEditor from "vue2-ace-editor"

export default {
  name: 'admin-query',
  components: {
    mdbContainer, mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    dataTable,
    gpSelect,
    YesNoModal,
    AceEditor
  },
  data() {
    return {
      rows: [],
      showDeleteModal: false,
      columns: [
        {label: "Name", field: "name"},
        {label: "Type", field: "type"}
      ],
      currentQuery: null,
      showQuery: false,
      showMain: true,
      queryResults: "",
      showResults: false,
      oldCode: "",
      testPayload: "",
      validTypes: [
        {text: "HQL", value: "HQL"},
        {text: "SQL", value: "SQL"}
      ]
    }
  },
  methods: {
    editorInit: function () {
      require('brace/ext/language_tools') //language extension prerequsite...
      require('brace/mode/sql')
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/ext/searchbox')
      require('brace/theme/textmate')
      require('brace/snippets/javascript') //snippet
    },
    deleteQuery: function () {
      this.showDeleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/batch/query/" + this.currentQuery.id).then(
        (results) => {
          this.showQuery = false
          this.showMain = true
          let loc = this.rows.indexOf(this.currentQuery)
          this.rows.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    newQuery: function () {
      this.currentQuery = {
        id: null,
        name: "",
        type: "HQL",
        parameters: ""
      }
      this.showMain = false
      this.showQuery = true
      this.showResults = false
      this.oldCode = ""
    },
    saveQuery: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/batch/query", this.currentQuery).then(
        (results) => {
          if (!this.currentQuery.id) this.currentQuery.id = results.data.id
          this.$store.dispatch("setDataTableReload")
          this.$notify.success({message: "Saved", timeOut: 3000})
          this.oldCode = this.currentQuery.code
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    testQuery: function () {
      if (this.currentQuery.parameters) {
        let payload
        try {
          payload = JSON.parse(this.testPayload)
        }
        catch (e) {
          this.$notify.error({message: "Invalid JSON Payload", timeOut: 6000})
          return
        }
        this.$store.dispatch("setExecuting", true)
        api.post("/batch/queryWithParams/" + this.currentQuery.name, payload).then(
          (results) => {
            this.queryResults = JSON.stringify(results.data, null, 2)
            this.showResults = true
            this.$nextTick().then(() => {
              let el = document.getElementById("results")
              if (el) {
                window.scrollTo(0, el.offsetTop)
              }
            });
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
      else {
        this.$store.dispatch("setExecuting", true)
        api.get("/batch/query/" + this.currentQuery.name).then(
          (results) => {
            this.queryResults = JSON.stringify(results.data, null, 2)
            this.showResults = true
            this.$nextTick().then(() => {
              let el = document.getElementById("results")
              if (el) {
                window.scrollTo(0, el.offsetTop)
              }
            });
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }

    },
    cancelShow: function () {
      this.showMain = true
      this.currentQuery = null
      this.showQuery = false
    },
    openQuery: function (row) {
      this.showMain = false
      this.currentQuery = row
      this.showQuery = true
      this.showResults = false
      this.oldCode = row.code
    }

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
